// extracted by mini-css-extract-plugin
module.exports = {"backButton":"style_backButton__1oW-a","backText":"style_backText__2y2h1"};